import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import ga from 'react-ga';
import { translate as t } from 'lang';
import { CargoType } from 'types';
import CategoryStore from 'stores/CategoryStore';
import CargosStore from 'stores/CargosStore';
import EditingCargoStore from 'stores/EditingCargoStore';
import ActionCreators from 'actions/ActionCreators';
import Cargos from 'components/Cargos';
import history from 'core/history';

import ButtonControl from 'components/ButtonControl';
import IconControl from 'components/IconControl';
import MobileBackButton from 'components/MobileBackButton';
import SubcategoriesConstants from 'constants/Subcategories';

import './MovingCargosScreen.scss';

function getStateFromStores() {
    return {
        selectedCategory : CategoryStore.getSelected(),
        allCargos        : CargosStore.getAllCargos(),
        cargos           : CargosStore.getDeliveryCargos(),
        isCargoTypesShown: CargosStore.isCargoTypesShown(),
        defaultCargo     : CargosStore.getCargoByStuffTypeId(SubcategoriesConstants.MOVING_ID)
    };
}

/**
 * Экран со списком доступных грузов.
 */
class MovingCargosScreen extends Component {

    static propTypes = {
        cargos: PropTypes.objectOf(CargoType)
    };

    constructor(props) {
        super(props);
        var storesState = getStateFromStores();

        this.state = {
            ...storesState,
            showCargosContainer: false
        }
    }

    componentDidMount() {
        CategoryStore.addChangeListener(this._onChange);
        CargosStore.addChangeListener(this._onChange);
        EditingCargoStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        CategoryStore.removeChangeListener(this._onChange);
        CargosStore.removeChangeListener(this._onChange);
        EditingCargoStore.removeChangeListener(this._onChange);
    }

    _onChange = () => {
        this.setState(getStateFromStores());
    };

    _onCargoFinish = () => {
        var categoryId = this.props.params ? this.props.params.categoryId : "";
        if (this.props.categoryId) categoryId = this.props.categoryId;
        ActionCreators.cargoComplete(categoryId, this.props.location.query);

        ga.event({
            category: 'orders',
            action  : 'add_orders_new_s2',
            label   : categoryId
        });
    };

    _onBackClick = () => {
        history.push({
            pathname: '/category/moving',
            state: null,
        });
    }

    _clickMobileBackButton = (stage) => {

        ga.event({
            category: 'buttons',
            action: 'click_button_booking_step_2',
            label: 'return_s1',
            value: 1,
        });

        ActionCreators.setStage(stage, this.props.location.query);
    }

    render() {
        var {
            cargos,
            isCargoTypesShown, defaultCargo,
            allCargos,
            } = this.state;

        var cargosContainer;
        if (cargos.size || this.state.showCargosContainer) {
            cargosContainer = (
                <Cargos cargos={cargos}
                        hasEditingCargo={isCargoTypesShown}
                        catergoryCargos={allCargos}
                        defaultCargo={defaultCargo}
                        addCargo={ false }
                    />
            );
        }

        var textAboveButtons = classNames([
            'CargosScreen-description',
            {
                '-active': cargos.size > 0
            }
        ]);

        return (
            <div className="CargosScreen container">
                <MobileBackButton label={selectedCategory.get('title')} address={'/'} onClick={this._clickMobileBackButton} />
                {cargosContainer}
                <div className={textAboveButtons}>
                    Если вы закончили добавление грузов, переходите на следующий шаг.
                </div>
                <div className="CargosScreen-buttons">
                    {
                        <ButtonControl
                            className="CargosScreen-back"
                            view="stone"
                            size="s"
                            leftIcon={<IconControl name="leftArrow"/>}
                            onClick={this._onBackClick}>
                            {t('BACK')}
                        </ButtonControl>
                    }
                    <ButtonControl className="CargosScreen-next"
                                   id="next_step"
                                   view="sand"
                                   size="s"
                                   shadow={false}
                                   disabled={cargos.size === 0}
                                   rightIcon={<IconControl name="rightArrow"/>}
                                   onClick={this._onCargoFinish}>
                        {t('NEXT_STEP')}
                    </ButtonControl>
                </div>
            </div>
        );
    }

}

export default MovingCargosScreen;



// WEBPACK FOOTER //
// ./client/components/MovingCargosScreen/MovingCargosScreen.js